import { gql } from '@apollo/client';

export const CONTRACTOR_CREATE = gql`
  mutation ContractorCreate($input: ContractorCreateInput!) {
    contractorCreate(input: $input) {
      id
      ownerUserId
      name
      phone
      email
      description
      availableArea {
        states
        counties
      }
      createdAt
      updatedAt
    }
  }
`;

export const CONTRACTOR_UPDATE = gql`
  mutation ContractorUpdate($id: ID!, $input: ContractorUpdateInput!) {
    contractorUpdate(id: $id, input: $input) {
      id
      ownerUserId
      name
      phone
      email
      description
      availableArea {
        states
        counties
      }
      createdAt
      updatedAt
    }
  }
`;

export const CONTRACTOR_MEMBERS_UPDATE = gql`
  mutation ContractorMembersUpdate(
    $id: ID!
    $addUserIds: [ID!]
    $removeUserIds: [ID!]
  ) {
    contractorMembersUpdate(id: $id, addUserIds: $addUserIds, removeUserIds: $removeUserIds) {
      id
      ownerUserId
      members {
        id
        name
        email
      }
    }
  }
`;

export const CONTRACTOR_DELETE = gql`
  mutation ContractorDelete($id: ID!) {
    contractorDelete(id: $id)
  }
`;
